import superagent from 'superagent'

export const huntPlannerActiveOptions = payload => ({
    type: 'HUNT_PLANNER_ACTIVE_SELECTED_OPTIONS',
    payload: payload
})

// Artemis set the selection (set_planner_filters): the top menu reruns its fetch-and-draw for it,
// as it does when the planner first opens with a selection.
export const huntPlannerArtemisApplied = () => ({ type: 'HUNT_PLANNER_ARTEMIS_APPLIED' })
